import { Blend } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

interface ConflictsStateProps {
  onResolve: () => void;
}

/**
 * Conflicts State Component
 * Displayed when data conflicts are detected
 */
export function ConflictsState({ onResolve }: ConflictsStateProps) {
  const { t } = useTranslation('authenticated.settings');

  return (
    <div className="flex flex-1 flex-col">
      <Badge variant="destructiveOutline" className="self-start font-medium">
        {t('pages.integrations.status.conflicts.badge')}
      </Badge>
      <span className="mt-3 font-medium">{t('pages.integrations.status.title')}</span>
      <span className="mt-2 text-sm text-muted-foreground">
        {t('pages.integrations.status.conflicts.subtitle')}
      </span>
      <Button size="sm" variant="default" className="mt-3 bg-chart-3" onClick={onResolve}>
        <Blend />
        {t('authenticated.settings:pages.integrations.refreshCard.conflicts.action')}
      </Button>
    </div>
  );
}
